export default __webpack_public_path__ + "static/media/header-ico-losang.d900f012.svg";